'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _reactRouter = require('react-router');

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module2Res7 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}, { changeItem: _modules.changeItem }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Res7, _Component);

  function Module2Res7() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Res7);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Res7.__proto__ || (0, _getPrototypeOf2.default)(Module2Res7)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currPage: 0,
      title: 'Cost saving shopping tips'
    }, _this.handleClickNext = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage + 1;
      _this.setState(obj);
    }, _this.handleClickPrev = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage - 1;
      _this.setState(obj);
    }, _this.handleOnClick = function (item, event) {
      event.preventDefault();
      console.log(event);
      console.log('CLICKED ' + item);
      var obj = _this.state;
      obj.currPage = item;
      _this.setState(obj);
    }, _this.handlePageOnClick = function (module, modtype, item, page, event) {
      console.log(event);
      _this.props.changeItem(module, modtype, item, page);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   *  User clicks on Next
   *  Increments the Page number and changes panel
   */


  /**
   *  User clicks on Previous
   *  Decrements the Page number and changes panel
   */


  /*
   * Quick link at the top to change the current page
   * to the selected page
   */


  // used to navigate to a resource item


  (0, _createClass3.default)(Module2Res7, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                'Module 2'
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Dividing your money:'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Spend the most on foods you should eat most of the time'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Vegetables, fruit and whole grain foods (eg. brown rice, multigrain bread, quinoa, barley etc.). These foods contain vitamins, minerals, and fibre. Remember the serve sizes from Module 2 - especially for whole grains.'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Spend moderately on foods you should eat in moderate amounts'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Lean red meat, fish, chicken, eggs, cheese, milk and nuts. These foods contain protein, vitamins and minerals.'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Spend least on foods you should eat the least of'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Chocolate, chips, biscuits, cordials, soft drinks and fatty meats. These foods are high in fat, sugar and salt, and don\'t provide many nutrients.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/module2', onClick: this.handlePageOnClick.bind(this, 2, 2, 3, 0) },
                'Click here for cost saving activity!'
              )
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Tips to save you money at the checkout'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Plan your meals before you go shopping: '
            ),
            _react2.default.createElement(
              'p',
              null,
              'The meal planner is a great tool to help you do this. Then write a shopping list so you know exactly wrhat to buy.'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Be flexible'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Where possible, take advantage of any specials.'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Check the price and quantity of bulk packages of fruits and vegetables'
            ),
            _react2.default.createElement(
              'p',
              null,
              'They are usually cheaper. You can freeze some of the vegetables and use them for cooking the next week.'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Buy fruit and vegetables that are in season'
            ),
            _react2.default.createElement(
              'p',
              null,
              'They tend to be less expensive and of better quality.'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Make the most of fruit and vegetables when they are plentiful or on special'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Buy extra and freeze (eg. blend fruit to make ice blocks or freeze vegetable soup)'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Plan meals around vegetables and grains (eg. rice, pasta) first, and then choose your meat'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Extend dishes with cheap vegetables or legumes'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Eg. bulk up a beef casserole with peas, carrots and corn, or make spaghetti bolognaise using half mince and half lentils.'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Prepare a vegetarian dish once a week'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'If fresh fruit or vegetables are in limited supply, check the price of frozen or canned varieties'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Frozen and canned fruit and vegetables are just as nutritious as fresh foods'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Frozen and canned fruit and vegetables are just as nutritious as fresh foods'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Choose varieties with no added sugar, salt or fat where possible'
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module2Res7;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  module: _propTypes2.default.number,
  modtype: _propTypes2.default.number,
  item: _propTypes2.default.number,
  page: _propTypes2.default.number,
  changeItem: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = Module2Res7;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/2/Res7.js
// module id = 1244
// module chunks = 0